import { render, staticRenderFns } from "./AdminWholesaler.vue?vue&type=template&id=1b69f047&"
import script from "./AdminWholesaler.vue?vue&type=script&lang=js&"
export * from "./AdminWholesaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports